import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { paginationLightToPagination } from '~/helpers';
import { localeStore } from '~/mobx/localesStore';
import { emptyArray } from '~/utils/helpers';
import ColumnTitle from '~/view/components/ColumnTitle/ColumnTitle';
import Pagination from '~/view/components/Controls/PaginationOld/PaginationOld';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import MessageCampaignListRow from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignListScreen/components/MessageCampaignListRow/MessageCampaignListRow';
import { messageCampaignListStore } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignListScreen/store/messageCampaignListStore';

const MessageCampaignList = observer(() => {
  useEffect(() => {
    messageCampaignListStore.fetchCampaigns();
  }, []);

  return (
    <div className="d-flex flex-column flex-grow-1 pt-4">
      {!messageCampaignListStore.pagination.total && !messageCampaignListStore.loading ? (
        <div className="d-flex flex-column justify-content-center align-items-center mt-2">
          <p className="family-medium text-size-24 color-gray2">{localeStore.t('no_results_found')}</p>
        </div>
      ) : (
        <>
          <div className="d-flex flex-row mb-4 pt-4 pr-5">
            <ColumnTitle title="marketing_mc_table_header_col" className="w-20" />
            <ColumnTitle title="marketing_mc_table_text_col" className="w-40" />
            <ColumnTitle title="marketing_mc_table_created_by_col" className="w-15" />
            <ColumnTitle
              title="marketing_mc_table_scheduled_time_col"
              className="w-25"
              tooltipMessage="marketing_mc_table_scheduled_time_col_infotip"
            />
          </div>
          <ScrollableBlock showScrollbar scrollClassName="d-flex flex-column full-height pr-2" className="mb-3 overflow-y-scroll">
            {messageCampaignListStore.loading && !messageCampaignListStore.pagination.total
              ? emptyArray().map((_, index) => <MessageCampaignListRow key={index} />)
              : messageCampaignListStore.campaigns.map((campaign) => <MessageCampaignListRow key={campaign.id} campaign={campaign} />)}
          </ScrollableBlock>
        </>
      )}
      <Pagination
        pagination={paginationLightToPagination(messageCampaignListStore.pagination, messageCampaignListStore.campaigns)}
        onChange={messageCampaignListStore.fetchCampaigns}
      />
      <LoadingOverlay visible={messageCampaignListStore.loading} refreshing />
    </div>
  );
});

export default MessageCampaignList;
